export enum ComponentKeys {
  AuditFinding = 'auditFinding',
  ImplementationGuidance = 'implementation_guidance',
}
